export const CARD_DIALOG_MODE = {
  VIEW_MODE: 'viewMode',
  EDIT_MODE: 'editMode',
};
